import React from "react";
import { BookOpen } from "@phosphor-icons/react";

const GUIDES = [
  ["postbacks-overview", "How postbacks work"],
  ["postbacks-voluum", "Voluum"],
  ["postbacks-redtrack", "RedTrack"],
  ["postbacks-everflow", "Everflow"],
  ["postbacks-tune", "TUNE (HasOffers)"],
  ["postbacks-binom", "Binom"],
  ["postbacks-any-tracker", "Any other tracker"],
];

// Links into the step-by-step Help Center guides for each tracker.
export function GuideLinks() {
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="postback-guides">
      <span className="label-mono inline-flex items-center gap-1 mr-1"><BookOpen size={12} weight="bold" /> Set-up guides</span>
      {GUIDES.map(([slug, label]) => (
        <a key={slug} href={`/help?slug=${slug}`} target="_blank" rel="noopener noreferrer" data-testid={`postback-guide-${slug}`}
          className="border border-black bg-white px-2 py-0.5 text-[10px] uppercase tracking-widest transition-colors duration-100 hover:bg-black hover:text-white">
          {label}
        </a>
      ))}
    </div>
  );
}
